module.exports = __webpack_public_path__ + "assets/img/tx101_4.c30832f6.jpg";